// src/layout/AuthLayout.tsx
import React from 'react';
import { Box, Container } from '@mui/material';
import Logo from '../components/common/Logo'; // UPDATED: Import the new Logo component

interface AuthLayoutProps {
    children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center', // Keep the container vertically centered
                    alignItems: 'center',
                }}
            >
                {/* UPDATED: Use the reusable Logo component with reduced margin-bottom */}
                <Box sx={{ mb: 2 }}> {/* UPDATED: Reduced margin-bottom from 4 to 2 */}
                    <Logo height={56} /> {/* UPDATED: Match the increased Logo height */}
                </Box>

                {/* The main content box for the form, centered independently */}
                <Box
                    sx={{
                        width: '100%',
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: (theme) => `1px solid ${theme.palette.divider}`,
                        borderRadius: 2,
                        backgroundColor: 'background.paper',
                        position: 'relative', // Ensure the main content box is centered independently
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Container>
    );
};

export default AuthLayout;